import { render, staticRenderFns } from "./StatsVisualizer.vue?vue&type=template&id=c2f7cb94"
import script from "./StatsVisualizer.vue?vue&type=script&lang=js"
export * from "./StatsVisualizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports